import DataTableLib from 'datatables.net-dt';

/**
 * Custom reload button for datatables
 *
 * @example
 *    $('#table-orders').DataTable({
 *     buttons: [
 *       extend: 'reloadTable',
 *       text: 'Reload my Table Content',
 *       ajaxReload: true,
 *       locationReload: false,
 *       methodReload: callbackFunction,
 *     ]
 *    });
 */
$.fn.dataTable.ext.buttons.reloadTable = {
  text: 'Reload',
  action: function (_e, dt, _node, config) {
    if (config.locationReload) {
      location.reload();
    } else if (config.ajaxReload) {
      dt.clear().draw();
      dt.ajax.reload();
    } else if (config.methodReload) {
      dt.clear().draw();
      // Set the cache-control header so it will always revalidate data from the API
      let header = {
        'Cache-Control': 'max-age=0, must-revalidate',
      };
      config.methodReload(dt.table().node().id, header);
    }
  },
};

/**
 * Custom reload button for datatables
 *
 * @example
 *    $('#table-orders').DataTable({
 *     buttons: [
 *       extend: 'resetTable',
 *       text: 'Reset my Table Filters',
 *       ajaxReload: true
 *     ]
 *    });
 */
$.fn.dataTable.ext.buttons.resetTable = {
  text: 'Reset Search',
  action: function (_e, dt, _node, config) {
    dt.columns().every(function (col) {
      if (Object(dt.column(col).footer().lastChild).type === 'select-one') {
        $(dt.column(col).footer())[0].lastChild.selectedIndex = 0;
      } else if (Object(dt.column(col).footer().lastChild).type === 'text') {
        dt.column(col).footer().lastChild.value = '';
      }

      dt.column(col).search('');
    });

    if (config.ajaxReload) {
      // ajaxReload e.g. for the orders table, where an update of the filters is only visible after the data is reloaded
      dt.clear().draw();
      dt.ajax.reload();
    } else {
      // Only redraw the table, as the data is not reloaded for tables which are fully loaded
      dt.draw();
    }
  },
};

// TODO: sort function is not working properly
// $.extend($.fn.dataTableExt.oSort, {
//   'ip-address-pre': function (input) {
//     const [ipAddress, bitmask] = input.split('/');

//     return (
//       ipAddress
//         .split('.')
//         .map(part => part.padStart(3, '0'))
//         .join('.') +
//       '/' +
//       (bitmask || '32')
//     );
//   },
// });

// // TODO: wants to use the new API, but is not working properly
// // somehow the data is not loaded correctly
// // only after a couple of sorts, all data finally appears
// DataTableLib.ext.order['ip-address'] = function (settings, col) {
//   const a = this.api()
//     .column(col, { order: 'index' })
//     .nodes()
//     .map(function (td, _i) {
//       const input = td.textContent;
//       const [ipAddress, bitmask] = input.split('/');
//       return (
//         ipAddress
//           .split('.')
//           .map(part => part.padStart(3, '0'))
//           .join('.') +
//         '/' +
//         (bitmask || '32')
//       );
//     });

//   console.log('IP Address sort', a);
//   return a;
// };

function dataTableColumnChange(select, e, clickedIndex, _previousValue, tableId) {
  const dt = new DataTableLib(`#${tableId}`, { retrieve: true });

  if (clickedIndex !== null) {
    console.debug('Show/hide single table column');
    const column = dt.column(e.currentTarget[clickedIndex].value);
    column.visible(!column.visible());
  } else {
    console.debug('Reset visibility of table columns');
    dt.columns().every(column => {
      if (select.selectpicker('val').includes('' + column) || column === 0) {
        dt.column(column).visible(true);
      } else {
        dt.column(column).visible(false);
      }
    });
  }
}

function resetColumns(columns, select) {
  let visibleCols = [];
  columns.forEach(column => {
    if (column.sTitle && column.visible) {
      visibleCols.push('' + column.idx);
    }
  });
  select.selectpicker('val', visibleCols);
}

DataTableLib.feature.register('colvisCustom', function (settings) {
  const tableId = settings.sTableId;
  const div = $('<div/>').addClass('dataTables_column_selector');

  const insideDiv = $('<div/>');
  div.append(insideDiv);

  const select = $('<select/>', {
    name: tableId + '_fields',
    'aria-controls': tableId,
    class: 'selectpicker no-deselect',
    'data-live-search': 'true',
    'data-show-subtext': 'true',
    'data-size': '10',
    'data-non-selected-text': '- Select Columns -',
    'data-selected-text-format': 'count > 1',
    'data-dropdown-align-right': 'true',
    'data-dropup-auto': 'true',
    'data-container': 'body',
    'data-count-selected-text': '{0} columns visible',
    'data-width': '140px',
    multiple: 'true',
  });

  select.on('changed.bs.select', function (e, clickedIndex, _isSelected, previousValue) {
    dataTableColumnChange(select, e, clickedIndex, previousValue, tableId);
  });

  settings.aoColumns.forEach(column => {
    if (column.sTitle) {
      const selectItem = $('<option>').val(column.idx).text(column.sTitle);
      selectItem.data = column;
      if ((column.visible && column.bVisible !== false) || column.bVisible) {
        selectItem.attr('selected', 'true');
      }
      select.append(selectItem);
    }
  });

  const resetButton = $('<button class="btn btn-small" data-bs-toggle="tooltip" title="Reset Columns">')
    .append('<i class="fas fa-undo">')
    .on('click', () => resetColumns(settings.aoColumns, select));

  insideDiv.append(select);
  div.append(resetButton);
  // init only — calling refresh on an uninitialised element would render options twice
  select.selectpicker();

  return div[0];
});
